import { render } from "./home-view.vue?vue&type=template&id=78442626"
import script from "./home-view.vue?vue&type=script&setup=true&lang=js"
export * from "./home-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/home-view/home-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78442626"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78442626', __exports__)) {
    api.reload('78442626', __exports__)
  }
  
  module.hot.accept("./home-view.vue?vue&type=template&id=78442626", () => {
    api.rerender('78442626', render)
  })

}


export default __exports__